import { generateLocale } from './generate';

export default generateLocale([
  '昵称',
  '昵称不能少于3个字符',
  '邮箱',
  '请填写正确的邮件地址',
  '网址',
  '可选',
  '欢迎评论',
  '来发评论吧~',
  '提交',
  '回复',
  '取消回复',
  '评论',
  '刷新',
  '加载更多...',
  '预览',
  '表情',
  '上传图片',
  '秒前',
  '分钟前',
  '小时前',
  '天前',
  '刚刚',
  '正在上传',
  '登录',
  '退出',
  '博主',
  '置顶',
  '字',
  '评论字数应在 $0 到 $1 字之间！\n当前字数：$2',
  '匿名',
]);
